const Created = "created";
const Ordered = "ordered";
const Paid = "paid";
const Invalid = "invalid";

function all(): string[] {
  return [Created, Ordered, Paid, Invalid];
}

export default {
  Created,
  Ordered,
  Paid,
  Invalid,
  all
};
